import React from "react";
import "../styles/LoadingOverlay.css";


const LoadingOverlay = ({ text = "Loading...", fullscreen = true }) => {
  return (
    <div className={fullscreen ? "loading-overlay" : "loading-inline"}>
      <div className="loading-box">
        <div className="spinner" />
        <div className="loading-text">{text}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
